import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import {MenuContent} from "./menu/MenuContent.tsx";

export const SideMenu = () => {
    return (
        <Row className={'sticky-top'}>
            <Col>
                <Row>
                    <Col>
                        <MenuContent />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
